import { Route } from "react-router-dom"
import React from "react"
import ServiceRequestLayout from "./ServiceRequestLayout"
import ReviewRequest from "./ReviewRequest"
import AddVehicle from "./AddVehicle"
import ShopSelection from "./ShopSelection"
import Appointment from "./Appointment"
import { routerPaths } from "../../../v1/constants/paths"
import AddPaymentDetails from "./AddPaymentDetails"

export const ServiceRequest = (props) => {
  return (
    <Route
      path="/service-request"
      render={() => (
        <ServiceRequestLayout>
          <Route path={routerPaths.addVehicle} component={AddVehicle} />
          <Route path={routerPaths.shopSelection} component={ShopSelection} />
          <Route path={routerPaths.appointment} component={Appointment} />
          <Route path={routerPaths.reviewRequest} component={ReviewRequest} />
          <Route path={routerPaths.addPayment} component={AddPaymentDetails} />
        </ServiceRequestLayout>
      )}
    />
  )
}
